import styled from 'styled-components';
import welcomeAsset from '@/assets/trio-mailbox.svg';

export const Container = styled.div<{ isSmaller?: boolean }>`
  width: 100%;
  margin: 0 auto;
  padding: 0 15px;
  max-width: ${(props) => (props.isSmaller ? '660px' : '1160px')};
`;

export const Hero = styled.div`
  background: ${(props) => props.theme.colors['neutral-20']};
  padding: 34.5px;
  margin-bottom: 32px;
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 45px;
    margin-bottom: 64px;
  }
`;

export const CandidateGreetings = styled.h3`
  font-weight: 600;
  font-size: 26px;
  line-height: 30px;
  max-width: 360px;
  color: ${(props) => props.theme.colors['primary-60']};
  position: relative;
  display: inline-block;
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 26px;
    line-height: 30px;
  }
  &:after {
    position: absolute;
    content: '';
    width: 89px;
    height: 68px;
    background-image: url(${welcomeAsset});
    display: block;
    background-size: cover;
    right: -146px;
    top: -20px;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
      width: 138px;
      height: 103px;
      right: -202px;
      top: -30px;
    }
  }
`;

export const WelcomingText = styled.p<{ isBold?: boolean }>`
  line-height: 2rem;
  font-weight: 400;
  text-align: center;
  font-size: 14px;
  color: ${(props) => props.theme.colors['neutral-100']};
  margin-bottom: 24px;
  font-weight: ${(props) => (props.isBold ? 'bold' : '400')};
`;
